module.exports = __webpack_public_path__ + "assets/mp3/audio7/audio_7_1a.mp3";